exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-alert[data-v-735b0360]{font-weight:700;padding:0 15px;border-radius:5px;font-size:21px}.btn-sm[data-v-735b0360]{padding:5px 14px}.trash-btn[data-v-735b0360]{padding:5px;font-size:20px;cursor:pointer}.trash-btn[data-v-735b0360]:hover{opacity:.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-735b0360","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/order/OrderDetailEdit.vue
// module id = wLyp
// module chunks = 1